exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".confirm-logo-container{width:80%;-ms-flex-pack:center;justify-content:center}.confirm-logo-container a .logo{width:100%;height:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/routes/confirm.styl
// module id = 527
// module chunks = 0